import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const RegisterSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(validationPatterns.name, msg("firstNameLetters"))
    .min(2, msg("firstNameMin"))
    .max(50, msg("firstNameMax"))
    .required(msg("firstNameRequired")),
  lastName: Yup.string()
    .matches(validationPatterns.name, msg("lastNameLetters"))
    .min(2, msg("lastNameMin"))
    .max(50, msg("lastNameMax"))
    .required(msg("lastNameRequired")),
  email: Yup.string()
    .email(msg("emailInvalid"))
    .matches(validationPatterns.email, msg("emailFormat"))
    .required(msg("emailRequired")),
  phone: Yup.string()
    .matches(validationPatterns.phone, msg("phoneInvalid"))
    .required(msg("phoneRequired")),
  password: Yup.string()
    .matches(
      validationPatterns.password,
      msg("passwordPattern")
    )
    .min(6, msg("passwordMin"))
    .required(msg("passwordRequired")),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], msg("passwordsMatch"))
    .required(msg("passwordConfirmRequired")),
});
